import { useState, useEffect, useRef } from "react";
import "../styles/estilos/registro.css";
import { registrarUsuario } from "../services/api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Register() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [formData, setFormData] = useState({
    loginCode: "",
    dni: "",
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
  });

  const [errorMessages, setErrorMessages] = useState({
    loginCode: "",
    dni: "",
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
  });

  const validateField = (name, value) => {
    switch (name) {
      case "loginCode":
        if (!/^\d+$/.test(value)) return "Debe contener solo números.";
        if (value.length === 0) return "Este campo es obligatorio.";
        return "";
      
      case "dni":
        if (!/^\d{7,8}$/.test(value)) return "El DNI debe ser un número de 7 u 8 dígitos.";
        return "";
      
      case "firstname":
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value)) return "No debe tener números ni caracteres especiales.";
        if (value.trim().length === 0) return "Este campo es obligatorio.";
        return "";
      
      case "lastname":
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value)) return "No debe tener números ni caracteres especiales.";
        if (value.trim().length === 0) return "Este campo es obligatorio.";
        return "";
      
      case "phone":
        if (!/^\d+$/.test(value)) return "El teléfono debe contener solo números.";
        if (value.length < 8) return "El teléfono debe tener al menos 8 dígitos.";
        return "";
      
      case "email":
        if (!/\S+@\S+\.\S+/.test(value)) return "Ingrese un email válido.";
        return "";
      
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    const cleanedValue = value.trim();
    
    setFormData(prev => ({
      ...prev,
      [name]: cleanedValue
    }));

    const errorMessage = validateField(name, cleanedValue);
    setErrorMessages(prev => ({
      ...prev,
      [name]: errorMessage
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      newErrors[key] = error;
      if (error) isValid = false;
    });

    setErrorMessages(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) {
      return;
    }

    if (!validateForm()) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Por favor, complete todos los campos correctamente.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await registrarUsuario(formData);

      setShowSuccessMessage(true);
      
      Swal.fire({
        icon: "success",
        title: "¡Registro exitoso!",
        text: "Tu cuenta ha sido creada exitosamente.",
        timer: 3000,
        showConfirmButton: false
      });
   
      navigate("/", { replace: true });
    } catch (error) {

      console.error("Error al enviar la solicitud:", error);

      let errorMessage = "A ingresado algún dato incorrecto, por favor verifique.";
      
      if (error.name === 'AbortError') {
        errorMessage = "La solicitud tardó demasiado tiempo. Por favor, intente nuevamente.";
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonText: "Entendido"
      });
    }
  };

  const handleGoBack = () => {
    navigate(-1); 
  };

  return (
    <>
      <div className="container-fluid p-0">
        <form
          onSubmit={handleSubmit}
          className="bg-dark text-white p-5 estiloform bg-image formRegistro"
        >
          <div className="text-center mb-5">
            <h1 className="mb-3 textoh1">
              Crear <span style={{ color: "#d54ab7" }}>Cuenta</span> Blue!
            </h1>
          </div>

          <div className="input-container">
            {showSuccessMessage && (
              <div className="alert alert-success mb-3" role="alert">
                Cuenta creada exitosamente. Redirigiendo...
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="loginCode" className="form-label">
              Código de acceso: *
            </label>
            <input
              type="text"
              name="loginCode"
              value={formData.loginCode}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.loginCode ? 'is-invalid' : ''}`}
              required
              disabled={isSubmitting}
            />
            {errorMessages.loginCode && (
              <div className="invalid-feedback d-block">
                {errorMessages.loginCode}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="dni" className="form-label">
              DNI: *
            </label>
            <input
              type="text"
              name="dni"
              value={formData.dni}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.dni ? 'is-invalid' : ''}`}
              required
              maxLength="8"
              disabled={isSubmitting}
            />
            {errorMessages.dni && (
              <div className="invalid-feedback d-block">
                {errorMessages.dni}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="firstname" className="form-label">
              Nombre: *
            </label>
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.firstname ? 'is-invalid' : ''}`}
              required
              disabled={isSubmitting}
            />
            {errorMessages.firstname && (
              <div className="invalid-feedback d-block">
                {errorMessages.firstname}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="lastname" className="form-label">
              Apellido: *
            </label>
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.lastname ? 'is-invalid' : ''}`}
              required
              disabled={isSubmitting}
            />
            {errorMessages.lastname && (
              <div className="invalid-feedback d-block">
                {errorMessages.lastname}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              Teléfono: *
            </label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.phone ? 'is-invalid' : ''}`}
              required
              disabled={isSubmitting}
            />
            {errorMessages.phone && (
              <div className="invalid-feedback d-block">
                {errorMessages.phone}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email: *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`custom-input2 ${errorMessages.email ? 'is-invalid' : ''}`}
              required
              disabled={isSubmitting}
            />
            {errorMessages.email && (
              <div className="invalid-feedback d-block">
                {errorMessages.email}
              </div>
            )}
          </div>

          <div className="mt-3 mb-1 d-flex justify-content-center align-items-center gap-3">
            <button 
              type="button" 
              className="btn btn-primary btn-color" 
              onClick={handleGoBack}
              disabled={isSubmitting}
            >
              Volver
            </button>
            <button 
              type="submit" 
              className="btn btn-primary btn-color"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  Registrando
                </>
              ) : (
                "Registrarse"
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}